import React from 'react';
import {Button, Header, Card, Icon, Modal, Loader, Dimmer, Label, Container, Table} from 'semantic-ui-react';
import CommercialTable from '../common/components/commercialTable/commercialTable';
import {useCommercialUsers} from './state/useCommercialUsers';
import {DefaultColumnFilter} from '../manageOrders/components/internalCommons/TableFilters';
import {FilePond, registerPlugin} from 'react-filepond';
import {MAXFILESIZE, MAXTOTALFILESIZE} from '../vehicleCertification/constants';
import {catalogTransactions} from '../common/dictionaries/parameters';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import XLSX from 'xlsx';
// import BaseUpdateTable from './components/baseUpdateTable';

registerPlugin(
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview,
  FilePondPluginFileRename,
);

const excelHeaders = ['concesionario', 'agencia', 'departamento', 'correo', 'nombres', 'apellidos',
  'cargo', 'ciudad', 'telefono', 'usuario', 'exportado', 'activo'];

const CommercialUsers = () => {
  const {values, functions, handlers} = useCommercialUsers();

  const handleDropFile = (acceptedFile) => {
    if (acceptedFile) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, {'type': 'binary'});
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, {'header': excelHeaders});
        data.shift();
        handlers.handleDataToUpdate(data);
      };
      reader.readAsBinaryString(acceptedFile);
    }
  };

  return <>
    <Card fluid style={{'padding': '1rem'}}>
      <div style={{'display': 'flex', 'justifyContent': 'space-between'}}>
        <Header as={'h1'} textAlign='left' size='large' >
          Mantenimiento y Gestión de Usuarios
          {!values.isTDE ? `${' -'} ${values.dealerName}` : ''}
        </Header>
        <div className="ui right aligned">
          {
            values.isTDE && <>
              <Modal size='large'
                open={values.showUpdateBaseModal}
                trigger={<Button
                  onClick={() => handlers.handleShowModalButton(true)} color='green'>ACTUALIZAR BASE</Button>}>
                <Modal.Header>Actualización de Base de Datos de Usuarios</Modal.Header>
                <Modal.Content>
                  <Modal.Description>
                    Seleccione el archivo Excel con la información actualizada.
                  </Modal.Description>
                  <FilePond
                    maxFileSize={MAXFILESIZE}
                    maxTotalFileSize={MAXTOTALFILESIZE}
                    acceptedFileTypes={[catalogTransactions.others.fileType]}
                    credits={false}
                    onupdatefiles={(fileItems, e) => {
                      fileItems.length > 0 && handleDropFile(fileItems[0].file);
                    }}
                    allowMultiple={false}
                    labelIdle='Arrastrar archivo o <span class="filepond--label-action">Navegador</span>'
                  />
                  <Label>Total registros para cargar: {values.dataToUpdate?.length}</Label>
                  <Container fluid as='div' style={{'marginTop': '1em'}}>
                    { values.loading &&
                      <Table striped className="toyota-grid">
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell colSpan="100%">
                              <Loader active inline='centered' content="Ejecutando..." />
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table> }
                    {
                      values.validationMessage === 'Error' && values.invalidRowsValidation.length > 0 &&
                        <>
                          <Label color='red'>La base de datos no ha sido actualizada.</Label>
                          <Label color='red'>Registros con errores: {values.invalidRowsValidation.length}</Label>
                          <Modal.Description>
                            (Los campos de Agencia y/o Concesionario no coinciden con los definidos en el sistema)
                          </Modal.Description>
                          <Table columns={10} celled>
                            <Table.Body>
                              {values.invalidRowsValidation.map((row, i) => {
                                return <Table.Row key={i}>
                                  <Table.Cell width={3}>{row.concesionario}</Table.Cell>
                                  <Table.Cell width={3}>{row.agencia}</Table.Cell>
                                  <Table.Cell width={3}>{row.departamento}</Table.Cell>
                                  <Table.Cell width={3}>{row.correo}</Table.Cell>
                                  <Table.Cell width={3}>{row.nombres}</Table.Cell>
                                  <Table.Cell width={3}>{row.apellidos}</Table.Cell>
                                </Table.Row>;
                              })}
                            </Table.Body>
                          </Table>
                        </>
                    }
                    { values.validationMessage && values.validationMessage !== 'Error' &&
                      <Label color='green'>{values.validationMessage}</Label> }
                  </Container>
                </Modal.Content>
                <Modal.Actions>
                  <Button onClick={() => handlers.handleShowModalButton(false)} color='grey'
                    disabled={values.loading}>CANCELAR</Button>
                  {values.dataToUpdate?.length > 0 &&
                    <Button onClick={functions.confirmUpdate} color='teal' disabled={values.loading}
                      loading={values.loading}>
                      CONFIRMAR ACTUALIZACIÓN</Button>
                  }
                </Modal.Actions>
              </Modal>
              <Button onClick={functions.downloadExcel} color='teal'>REPORTE EXCEL</Button>
              <Button onClick={functions.downloadCSV} color='blue'>EXPORTAR CSV</Button>
            </>
          }
          <Button color='red' onClick={handlers.handleBotonGuardar}>GUARDAR</Button>
        </div>
      </div>
    </Card>
    <div style={{'display': 'flex', 'justifyContent': 'space-between', 'alignItems': 'center', 'marginBottom': '10px'}}>
      <Header as={'h3'} textAlign='left'>N° de registros: {values.filteredData.length}</Header>
      <Button onClick={functions.addNewUser} color='green'>
        <span style={{'marginRight': '1em'}}>
        NUEVO USUARIO
        </span>
        <Icon name='add user' link color='white' />
      </Button>
    </div>
    {
      values.loading ?
        <Dimmer active inverted>
          <Loader />
        </Dimmer> :
        <CommercialTable
          columns={values.columns}
          data={values.data}
          defaultColumnFilter={DefaultColumnFilter}
          setFilteredData={functions.setFilteredData}
          isSmallCell={true}
        />
    }
    <Modal
      open={values.showConfirmationModal}
      size='mini'
    >
      <Modal.Header>Guardar cambios</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          ¿Desea guardar los cambios?
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color='red' onClick={functions.saveChanges}>SI</Button>
        <Button color='yellow' onClick={() => functions.setShowConfirmationModal(false)}>NO</Button>
      </Modal.Actions>
    </Modal>
    <Modal
      open={values.showThanksModal}
      size='mini'
    >
      <Modal.Header>¡Muchas Gracias!</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          Toyota del Ecuador procederá a revisar los cambios.
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color='green' onClick={functions.hideThanksModal}>ACEPTAR</Button>
      </Modal.Actions>
    </Modal>
  </>;
};

export default CommercialUsers;
